"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationsDevInitializer = exports.TranslationInitializer = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const translations_1 = require("./translations");
const TRANSLATIONS_FLAG_ERROR = 'Translations initialization error';
class TranslationsInitializationError extends web_ui_framework_1.InitializerError {
    constructor(message) {
        super(TRANSLATIONS_FLAG_ERROR, message);
    }
}
class TranslationInitializer extends web_ui_framework_1.Initializer {
    constructor(config, api) {
        super([api]);
        this.launch = async () => {
            try {
                await (0, translations_1.initConfigAndTranslations)(this.api.getInitialized(), this.config);
            }
            catch (e) {
                throw new TranslationsInitializationError(e);
            }
        };
        this.config = config;
        this.api = api;
    }
}
exports.TranslationInitializer = TranslationInitializer;
class TranslationsDevInitializer extends web_ui_framework_1.Initializer {
    constructor(config, api) {
        super([api]);
        this.launch = async () => {
            try {
                await (0, translations_1.initConfigWebAndOwnTranslations)(this.api.getInitialized(), this.config);
            }
            catch (e) {
                throw new TranslationsInitializationError(e);
            }
        };
        this.config = config;
        this.api = api;
    }
}
exports.TranslationsDevInitializer = TranslationsDevInitializer;
//# sourceMappingURL=translations.initializer.js.map